// Option lists unique to <ContractForm>; the shared ones live in config/formOptions.js.
import { createYesNoOptions } from '@/config/formOptions';

export const MULTI_SITE_TRANSFER = Object.freeze({ no: 'no', yes: 'yes' });

export const buildMultiSiteTransferOptions = createYesNoOptions(MULTI_SITE_TRANSFER);
